const TICK_SCREEN_PREFIX = "tick";

export const TICK_SCREEN_TEST_IDS = {
    CONTAINER: `${TICK_SCREEN_PREFIX}_container`,
    SVG: `${TICK_SCREEN_PREFIX}_svg`,
    MAIN_TEXT: `${TICK_SCREEN_PREFIX}_main`,
    SUPER_TEXT: `${TICK_SCREEN_PREFIX}_super`,
    SUB_TEXT: `${TICK_SCREEN_PREFIX}_sub`,
    INTERMEDIATE_TEXT: `${TICK_SCREEN_PREFIX}_intermediate`,
    ADDRESS_TEXT: `${TICK_SCREEN_PREFIX}_address`,
    ADDRESS_ICON: `${TICK_SCREEN_PREFIX}_address_icon`,
    ADDRESS_ANNOTATION: `${TICK_SCREEN_PREFIX}_address_annotation`,
    SAVINGS_TEXT: `${TICK_SCREEN_PREFIX}_savings`,
    BLACK_MEMBERSHIP_BENEFITS: `${TICK_SCREEN_PREFIX}_black_membership_benefits`,
    FOOTER_SUCCESS_ICON: `${TICK_SCREEN_PREFIX}_footer_success_icon`,
    TICK_SCREEN_CONTENT: `${TICK_SCREEN_PREFIX}_content`,
};
